import LocalizedStrings from 'localized-strings';

interface SelectFromBankAccountLocales {
  fromAccount: string;
}

const locales = new LocalizedStrings<SelectFromBankAccountLocales>({
  en: {
    fromAccount: 'Select the wallet to be debited',
  },
  fr: {
    fromAccount: 'Sélectionnez le compte à débiter',
  },
} as const);

export default locales;
